<template>
  <div id="Music" class="flex" cols="12" sm="12">
    <h1>vibration</h1>
    <v-switch v-model="switch1" inset :label="`Want to vibration ?: ${switch1.toString()}`"></v-switch>

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-container>
        <v-row>
          <v-col cols="12" md="12">
            <v-select
              v-model="selected"
              :disabled="!switch1"
              :items="notificationValues"
              label="Select Vibration Seconds"
              @change="myD"
              outlined
            ></v-select>
            <center style="font-size: 40px;">
              <v-btn color="success" class="mr-4" @click="saveBrightness()">Save & Play</v-btn>
              <br />
            </center>
          </v-col>
        </v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :right="x === 'right'"
          :top="y === 'top'"
          :color="color"
        >
          {{ text }}
          <v-btn color="blue" text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-container>
    </v-form>
  </div>
</template>
<style scoped>
</style>
<script>
import { appConfig } from "../../firebaseConfig";
export default {
  name: "Vibration",
  data() {
    return {
      switch1: false,
      length: 5,
      valid: false,
      search: "",
      musicUrl: "",
      musicRules: [
        v => !!v || "Music URL is required",
        v => /\.(?:wav|mp3)$/i.test(v) || "Music must be valid"
      ],
      selected: null,
      notificationValues: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      myitems: [],
      latitude: "",
      longitude: "",
      obj: {
         appVibration:{
            seconds:"",
            vibration:""
          },
          battryPercentage:"",
          isCharging:"",
          bluetooth:"",
          brightness:"",
          flashlight:"",
          mobileData:"",
          mobileDataType:"",
          musicUrl:{
            music:"",
            url:"",
          },
          sound:""
      },
      color: "",
      mode: "",
      snackbar: false,
      text: "Hello, I'm a snackbar",
      timeout: 6000,
      x: null,
      y: "top"
    };
  },
  mounted: function() {
    this.getObj();
  },
  methods: {
    async myD() {
      if (this.selected == null) {
        console.log(this.selected);
      } else if (this.selected == "Warriyo") {
        console.log(this.selected);
      } else if (this.selected == "LostSky") {
        console.log(this.selected);
      } else if (this.selected == "Jasico") {
        console.log(this.selected);
      } else if (this.selected == "Electro") {
        console.log(this.selected);
      }
    },
    getObj() {
      return appConfig
        .child("78KOHWXhC0UTR3fxqkqsoJ7j1Ew1")
        .child("868068040704064")
        .on("value", snapshot => {
          this.obj = snapshot.val();
          console.log(this.obj);
        });
    },
    saveBrightness() {
      this.obj.appVibration.vibration = this.switch1;
      console.log(this.selected);
      if (this.selected === null) {
        this.obj.appVibration.seconds = "5";
      } else {
        this.obj.appVibration.seconds = this.selected;
      }
      console.log(this.obj);
        appConfig
          .child("78KOHWXhC0UTR3fxqkqsoJ7j1Ew1")
          .child("868068040704064")
          .set(this.obj);
      this.text = "successfully Changes";
      this.snackbar = true;
      this.color = "success";
    }
  }
};
</script>